/* eslint-disable */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-vars */
// const CONSTANTS = require('../../commons/constants')

let isProspectorParser = false
let currentUrl = ''
let documentObject = ''
let isServerParserEnabled = false
let isServerParserEnabledTriggered = false
let LI_CHOOSEN_LANGUAGE = ''

let WEB_URL = 'http://localhost:8080/'
if (process.env.VUE_APP_BUILD_ENV === 'staging') {
  WEB_URL = 'https://www.adaptqe.com/'
} else if (process.env.VUE_APP_BUILD_ENV === 'production') {
  WEB_URL = 'https://www.adapt.io/'
}

const experienceSectionV1Xpath = '//section[contains(@id, "EXPERIENCE")]'
const experienceSectionV1ItemXpath =
  './/li[contains(@class,"artdeco-list__item")]'
const experienceSectionV2Xpath = '//*[@id="experience"]/parent::section'
const experienceSectionV2ItemXpath =
  './div[contains(@class, "pvs-list__outer-container")] /ul /li'
const experienceSectionV3ItemXpath = './/ul/li'

function checkIsProspectorWindow() {
  const host = window.location.host
  if (
    host.includes('http://localhost:8081') ||
    host.includes('https://prospector.adaptqe.com') ||
    host.includes('https://prospector.adapt.io')
  ) {
    return true
  }
  return false
}
const envErrorObj = {
  error: 'env_error',
  errorMessage: 'Environment value incorrect',
  data: {
    isProspectorParser
  }
}

if (!isProspectorParser && !checkIsProspectorWindow()) {
  function checkIsServerParserEnabled() {
    get('lp/isServerParserAllowed.htm').then(function(res) {
      if (res == 'true') {
        isServerParserEnabled = true
      } else {
        isServerParserEnabled = false
      }
    })
  }

  function get(path) {
    const url = WEB_URL + path
    return getFromUrl(url)
  }

  function getFromUrl(url) {
    const params = {
      url: url,
      method: 'GET',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    }
    return sendRestCallToBg(params)
  }

  function sendRestCallToBg(data) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      try {
        return (
          chrome &&
          chrome.runtime &&
          chrome.runtime.sendMessage(
            {
              method: 'rest',
              value: data
            },
            function(value) {
              resolve(value)
            }
          )
        )
      } catch (error) {
        return ''
      }
    })
  }
  if (!isServerParserEnabledTriggered) {
    isServerParserEnabledTriggered = true
    checkIsServerParserEnabled()
  }
}

export const singleParser = stubData => {
  if (
    stubData !== undefined &&
    stubData !== null &&
    stubData.isProspectorParser !== undefined &&
    stubData.isProspectorParser
  )
    isProspectorParser = true
  else isProspectorParser = false
  if (!setEnvBasedValues(stubData))
    return new Promise(resolve => {
      resolve(envErrorObj)
    })
  return new Promise(resolve => {
    return resolve(parseUserDataFromLIParserFun())
  })
}
export const bulkParser = stubData => {
  if (
    stubData !== undefined &&
    stubData !== null &&
    stubData.isProspectorParser !== undefined &&
    stubData.isProspectorParser
  )
    isProspectorParser = true
  else isProspectorParser = false
  if (!setEnvBasedValues(stubData))
    return new Promise(resolve => {
      resolve(envErrorObj)
    })
  return new Promise(resolve => {
    return resolve(fetchBulkDataParserFun())
  })
}

export const companyParser = stubData => {
  if (
    stubData !== undefined &&
    stubData !== null &&
    stubData.isProspectorParser !== undefined &&
    stubData.isProspectorParser
  )
    isProspectorParser = true
  else isProspectorParser = false
  if (!setEnvBasedValues(stubData))
    return new Promise(resolve => {
      resolve(envErrorObj)
    })
  return new Promise(resolve => {
    return resolve(salesNavigatorCompanyParser())
  })
}

function constructDocumentObj(str) {
  let doc = document.implementation.createHTMLDocument('')
  doc.open('replace')
  doc.write(str)
  doc.close()
  return doc
}

function setEnvBasedValues(stubData) {
  try {
    if (isProspectorParser && stubData !== undefined && stubData !== null) {
      if (stubData.currentUrl) currentUrl = stubData.currentUrl
      if (stubData.htmlText)
        documentObject = constructDocumentObj(stubData.htmlText)
    } else {
      if (window) {
        window.location &&
          window.location.href &&
          (currentUrl = window.location.href)
        window.document && (documentObject = window.document)
      }
    }
    return true
  } catch (error) {
    console.log(
      'Environment value incorrect isProspectorParser',
      isProspectorParser
    )
    return false
  }
}

function getURL(url) {
  let url_parts
  try {
    url_parts = new URL(url, 'https://www.linkedin.com')
  } catch (e) {
    url_parts = new URL(url)
  }
  return url_parts
}

function getSearchStringFromUrl(urlVal = currentUrl) {
  let url_parts = {
    search: ''
  }
  url_parts = getURL(urlVal)
  return url_parts.search || ''
}

function getPathname(urlVal = currentUrl) {
  let url_parts = {
    pathname: ''
  }
  url_parts = getURL(urlVal)
  return url_parts.pathname || ''
}

function getPathnameWithQueryParam(urlVal = currentUrl) {
  let url_parts = {
    pathname: '',
    search: ''
  }
  url_parts = getURL(urlVal)
  return url_parts.pathname + url_parts.search || ''
}

function trimSpacesAndNewLine(str) {
  return str
    .split('\n')
    .map(d => {
      if (d) {
        if (d.trim() == '') return ''
        return d.trim() + ' '
      }
      return ''
    })
    .join('')
    .trim()
}
function nullCheck(value) {
  if (value == undefined || value == null || value == '') {
    return true
  }
  return false
}

/* Single Parser Starts */
const parseUserDataFromLIParserFun = () => {
  return new Promise(resolve => {
    let profileData = {}
    if (isServerParserEnabled) {
      profileData.isServerParserEnabled = true
      profileData.profileHTML = document.documentElement.innerHTML
      profileData.currentUrl = window.location.href
    } else {
      try {
        profileData.linkedinId = getLinkedinId()
        profileData.linkedinLanguage = getLinkedinSelectedLanguage()
        LI_CHOOSEN_LANGUAGE = profileData.linkedinLanguage

        const experience = documentObject.querySelector('#experience ~ div ul')

        let cName = getCompanyNameFromExpSec()
        let cAddress = getCompanyAddress(cName)
        let company = {
          domain: '',
          name: cName ? cName.trim() : '',
          address: cAddress
        }
        profileData.tryUserInfoSection = false
        profileData.source = 'LINKEDIN'
        profileData.company = company
        profileData.fullName = getFullName()
        profileData.firstName = getFirstName()
        profileData.lastName = getLastName()

        profileData.title = getTitle()
        profileData.linkedinCompanyPageUrl = getCurrentCompanyPageUrl()
        profileData.isActivelyWorking = isActivelyWorkingInFirstCompany(
          experience
        )
        if (
          profileData.linkedinCompanyPageUrl &&
          hasLinkedInCompanyPage(profileData.linkedinCompanyPageUrl)
        ) {
          profileData.isValidDomain = true
        } else {
          profileData.isValidDomain = false
          profileData.linkedinCompanyPageUrl = null
        }
        profileData.listParameter = 'linkedin'

        profileData.city = getCity()
        profileData.connections = getConnections()
        profileData.experience = getPastExperience()
        profileData.activeCompanyLIURLs = getAllActiveCompanies()
        profileData.address = getAddress()
        profileData.profileHeadline = getProfileHeadline()
        profileData.isSaleNavigator = isSalesNavigator()

        if (
          (nullCheck(cName) &&
            (nullCheck(profileData.experience) ||
              profileData.experience.length == 0)) ||
          nullCheck(profileData.fullName) ||
          nullCheck(profileData.title) ||
          nullCheck(profileData.linkedinId)
        ) {
          profileData.domReadError = true
          profileData.profileHTML = document.documentElement.innerHTML
          profileData.currentUrl = window.location.href
        }
      } catch (err) {
        profileData.domReadError = true
        profileData.profileHTML = document.documentElement.innerHTML
        profileData.currentUrl = window.location.href
        return resolve(profileData)
      }
    }
    return resolve(profileData)
  })
}

function getLinkedinSelectedLanguage() {
  const languageMetaElement = documentObject.querySelector(
    "meta[name='i18nLocale']"
  )
  const selectLangauageElement = document.querySelector(
    '#globalfooter-select_language'
  )
  let languageText = ''
  if (languageMetaElement !== null)
    languageText = languageMetaElement.getAttribute('content')
  else if (selectLangauageElement !== null)
    languageText = selectLangauageElement.value

  return languageText
}

function getCompanyNameFromExpSec() {
  let company
  if (isNotSalesNavigator()) {
    let companySection = documentObject.querySelector('#experience ~ div ul')
    const recentExperience = getLatestExperienceInfo()

    if (companySection) {
      company = getTagNameElementFromHTMLElement(companySection, 'a', 0)

      if (isValidCompany(company)) {
        const element = documentObject.querySelector('#experience ~ div > ul  > li:first-child')
        if(element) {
          const experienceListInParticularCompany = element.querySelectorAll('a:not([data-field="position_contextual_skills_see_details"])')
          if(!experienceListInParticularCompany || (experienceListInParticularCompany && experienceListInParticularCompany.length > 2)) {
            let name = documentObject.querySelector(
              '#experience ~ div > ul  > li:first-child .hoverable-link-text span'
            )
            if (name != undefined) {
              return trimSpacesAndNewLine(name.innerText)
            }
          } 
        }
        let name = documentObject.querySelector(
          '#experience ~ div ul li .t-normal span'
        )
        if (!name) {
           name = documentObject.querySelector('#experience ~ div ul li .t-normal span[aria-hidden="true"]')
        }
        if (name != null) {
          return trimSpacesAndNewLine(name.innerText).split('·')[0]
        }
      }
    }
    
    if (recentExperience) { 
      return getCompanyNameFromV1GroupEXPERIENCE(recentExperience);
    }
  } else {
    if (isSalesNavigatorLead()) {
      const companyName =
        getElementByXpath(
          "//*[@id='experience-section']/ul/li[1]/div/div/a/p"
        ) ||
        documentObject.querySelector(
          "#experience-section [data-anonymize='company-name']"
        )
      if (companyName) return trimSpacesAndNewLine(companyName.innerText)
    } else {
      let companyData = documentObject.querySelector('#profile-experience')
      if (companyData) {
        companyData = companyData.getElementsByTagName('li')
        if (companyData[0]) {
          companyData = companyData[0].querySelector(
            '.profile-position__secondary-title'
          )
          if (companyData) {
            return trimSpacesAndNewLine(companyData.innerText).replace(
              'Company Name',
              ''
            )
          }
        }
      }
    }
  }
}

function getCompanyAddress(cName) {
  if (cName && isNotSalesNavigator()) {
    let companySection = documentObject.querySelector('#experience ~ div ul')
    const recentExperience = getLatestExperienceInfo()
    if (companySection) {
      let addressSection = companySection.querySelector(
        '.pv-entity__location'
      )
      let hiddenEle = null;
      if (addressSection) {
        hiddenEle = addressSection.querySelector(
          '.pv-entity__location .visually-hidden'
        )
      } else {
        const expDateSection = companySection.querySelector(
          ':scope .pvs-entity__caption-wrapper'
        )
        if (expDateSection) {
          const dateSpan = expDateSection.closest('span.t-normal');
          addressSection = dateSpan ? dateSpan.nextElementSibling : null;
          if (addressSection) {
            hiddenEle = addressSection.querySelector(':scope .visually-hidden')
          }
        }
      }
      if(addressSection) {
        const hiddenTxt = hiddenEle ? hiddenEle.innerText.trim() : ''
        return trimSpacesAndNewLine(addressSection.innerText)
          .replace(hiddenTxt, '')
          .replace(/(?:\r\n|\r|\n)/g, '').trim()
      }
    } else if (recentExperience) {
      return getAddressFromV1GroupEXPERIENCE(recentExperience)
    }
  }
}

function getFullName() {
  if (isNotSalesNavigator()) {
    const name = documentObject.querySelector('h1') || documentObject.querySelector('[data-view-name="profile-top-card-verified-badge"] h2') || documentObject.querySelector('h2')
    if (name !== null) return trimSpacesAndNewLine(name.innerText)
  } else {
    if (isSalesNavigatorLead()) {
      const name = documentObject.querySelector(
        '#profile-card-section section h1'
      )
      if (name !== null) return trimSpacesAndNewLine(name.innerText)
    } else {
      let nameElem = getElementByClassNameFromDom('member-name', 0)
      if (nameElem == undefined) {
        nameElem = getElementByClassNameFromDom(
          'profile-topcard-person-entity__name',
          0
        )
      }
      return trimSpacesAndNewLine(nameElem.innerText)
      //  for salesnavigator
    }
  }
}

function getFirstName() {
  const names = splitBySpace(getFullName())
  if (names[0]) return names[0]
}

function getLastName() {
  const names = splitBySpace(getFullName())
  if (names[1]) return names[1]
}

function getLatestExperienceInfo() {
  const expSectionV1 = getElementByXpath(experienceSectionV1Xpath)
  const expSectionV2 = getElementByXpath(experienceSectionV2Xpath)
  if (expSectionV1) {
    const recentExperience = getElementByXpath(
      experienceSectionV1ItemXpath,
      expSectionV1
    )
    return recentExperience
  } else if (expSectionV2) {
    let recentExperience = getElementByXpath(
      experienceSectionV2ItemXpath,
      expSectionV2
    )
    if (!recentExperience) {
        recentExperience = getElementByXpath(
          experienceSectionV3ItemXpath,
          expSectionV2
        )
    }
    return recentExperience
  }
}

function getTitle() {
  let titleSection
  if (isNotSalesNavigator()) {
    const expSelector = '#experience ~ div ul'
    const expSection = documentObject.querySelector(expSelector)
    const recentExperience = getLatestExperienceInfo()
    if (expSection) {
      if (hasMultipleTitle(expSelector)) {
        titleSection = documentObject.querySelector(
          '#experience ~ div ul .pvs-entity__sub-components ul li .visually-hidden'
        )
        if (titleSection && titleSection.innerText) {
          return trimSpacesAndNewLine(titleSection.innerText)
        }
      } else {
        let experienceListInParticularCompany = expSection.querySelector('li').querySelectorAll('a:not([data-field="position_contextual_skills_see_details"])')
        let title = null;
        if(experienceListInParticularCompany && experienceListInParticularCompany.length == 2) {
          title = getTitleSectionFromCompanyInfo(experienceListInParticularCompany[1]) || ''
        } 
        if(title) {
          return title;
        } else {
          titleSection = documentObject.querySelector(
            '#experience ~ div ul .visually-hidden'
          )
        }
      }
    } else if (recentExperience) {
      return getTitleFromV1GroupEXPERIENCE(recentExperience)
    }
  } else {
    if (isSalesNavigatorLead()) {
      const title = documentObject.querySelector(
        "#profile-card-section [data-anonymize='job-title']"
      )
      return title.innerText || ''
    } else {
      titleSection = getDataByClassNameTagName('position-info', 0, 'h2', 0)
      if (!titleSection) {
        titleSection = getDataByClassNameClassName(
          'profile-position',
          0,
          'profile-position__title',
          0
        )
      }
    }
  }
  if (titleSection) {
    return trimSpacesAndNewLine(titleSection.innerText)
  }
}

function getCurrentCompanyPageUrl() {
  let company
  if (isNotSalesNavigator()) {
    let companySection = documentObject.querySelector('#experience ~ div ul li')
    const recentExperience = getLatestExperienceInfo()
    if (companySection) {
      company = getTagNameElementFromHTMLElement(companySection, 'a', 0);
      
      if (isValidCompany(company)) { 
        if (company && company.href) { 
          let currentCompany = getPathnameWithQueryParam(company.href);

          if (currentCompany.indexOf('www.linkedin.com') == -1) {
            currentCompany = 'https://www.linkedin.com' + currentCompany;
          }
          if (hasLinkedInCompanyPage(currentCompany)) {
            return currentCompany;
          }
        }
      }
    }
    if (recentExperience) {
      company = getElementByXpath('.//a[@data-field="experience_company_logo"]', recentExperience);

      if (!company) {
        company = getElementByXpath('./div/div[1]/a', recentExperience);
      }
      if (!company) {
         company = getElementByXpath('.//a[contains(@class, "optional-action-target-wrapper")]', recentExperience);
      }

      if (company && company.href) {
        let currentCompany = getPathnameWithQueryParam(company.href);

        if (currentCompany.indexOf('www.linkedin.com') == -1) {
          currentCompany = 'https://www.linkedin.com' + currentCompany;
        }
        
        if (hasLinkedInCompanyPage(currentCompany)) {
          return currentCompany;
        }
      }

    }
  } else {
    if (isSalesNavigatorLead()) {
      const companyName = documentObject.querySelector(
        "#experience-section li p[data-anonymize='company-name']"
      )
      if (companyName !== null) {
        const companyLinkedinURL =
          'https://www.linkedin.com' +
          companyName.parentElement.getAttribute('href')
        return companyLinkedinURL
      } else if (
        getElementByXpath("//*[@id='experience-section']/ul/li[1]/div/div/a")
      ) {
        return (
          'https://www.linkedin.com' +
          getElementByXpath(
            "//*[@id='experience-section']/ul/li[1]/div/div/a"
          ).getAttribute('href')
        )
      }
    } else {
      company = getDataByClassNameTagName('position', 0, 'a', 0)
      if (company) {
        return getCompanyUrlSn(company)
      } else {
        company = getDataByClassNameTagName('profile-position', 0, 'a', 0)
        return getCompanyUrlForNewSn(company)
      }
    }
  }
}

function isActivelyWorkingInFirstCompany(element) {
  if (isNotSalesNavigator()) {
    let currentWorking = element.querySelector(
      '.pvs-entity__sub-components .pvs-entity__caption-wrapper'
    )
    if (!currentWorking) {
      currentWorking = getClassNameElementFromHTMLElement(
        element,
        'pvs-entity__caption-wrapper',
        0
      )
    }
    const recentExperience = getLatestExperienceInfo()
    if (currentWorking && checkIsPresentTextMatch(currentWorking.innerText)) {
      return true
    } else if (recentExperience) {
      return getActivelyWorkingInfoFromV1GroupEXPERIENCE(recentExperience)
    }
  } else {
    if (isSalesNavigatorLead()) {
      const latestCompany = documentObject.querySelector(
        '#experience-section ul li:first-child'
      )
      if (latestCompany !== null) {
        return checkIsPresentTextMatch(latestCompany.innerText)
      }
    } else {
      let companyData = documentObject.querySelector('#profile-experience')
      if (companyData) {
        companyData = companyData.getElementsByTagName('li')
        if (companyData[0]) {
          return checkIsPresentTextMatch(companyData[0].innerText)
        }
      }
    }
  }
}

function getCity() {
  let location
  if (isNotSalesNavigator()) {
    location = getElementByClassNameFromDom('pv-top-card-section__location', 0)
    if (!location) {
       location = documentObject.querySelector('.text-body-small.inline.t-black--light.break-words')
    }
    if (location != undefined && location.innerText.length > 0) {
      return trimSpacesAndNewLine(location.innerText).split(',')[0]
    }
    if (!location) {
      const topCard = documentObject.querySelector('[componentkey*="Topcard"]')
      if (topCard) {
        const paragraphs = topCard.querySelectorAll('p')
        if (paragraphs.length >= 3) {
          location = paragraphs[2]
          if (location) {
            return trimSpacesAndNewLine(location.innerText).split(',')[0]
          }
        }
      }
    }
  } else {
    if (isSalesNavigatorLead()) {
      location =
        documentObject.querySelector(
          "#profile-card-section [data-anonymize='location']"
        ) ||
        getElementByXpath(
          "//*[@id='profile-card-section']/section[1]/div/div[4]"
        )
    } else {
      location = getElementByClassNameFromDom('location', 6)
      if (!location) {
        location = getElementByClassNameFromDom('location', 0)
      }
      if (!location) {
        location = getElementByClassNameFromDom(
          'profile-topcard__location-data',
          0
        )
      }
    }
    if (location != undefined && location.innerText.length > 0) {
      return trimSpacesAndNewLine(location.innerText).split(',')[0]
    }
  }
}

function getConnections() {
  if (isNotSalesNavigator()) {
    let element = documentObject.querySelector('[data-member-id] > div > ul')
    if (element && element.querySelectorAll('li').length) {
      let connection = ''
      element.querySelectorAll('li').forEach(function(eleItem) {
        let data = eleItem.innerText
        if (data.includes('connection')) {
          connection = trimSpacesAndNewLine(data).replace(/\D/g, '')
        }
      })
      if(!connection) {
        const boldElement = element.querySelector('li .t-bold')
        if(boldElement) {
            connection = trimSpacesAndNewLine(boldElement.innerText).replace(/\D/g, '')
        }
      }

      return connection
      //convert string to number
    } else {
       const pTags = documentObject.querySelectorAll('p')
       for(let p of pTags) {
         if(p.innerText.includes('connections')) {
           const numberP = p.previousElementSibling
           if(numberP) {
             return trimSpacesAndNewLine(numberP.innerText).replace(/\D/g, '')
           }
         }
       }
    }
  }
}

function getLinkedinId() {
  if (isNotSalesNavigator()) {
    let element = getDataByClassNameTagName('ci-vanity-url', 0, 'a', 0)
    if (element != undefined) {
      return trimSpacesAndNewLine(element.innerText)
    } else {
      return constructLinkedinIdFromWindowUrl()
    }
  } else {
    //if(){
    //}else{
    //  return constructLinkedinIdFromWindowUrl('sn');
    //}
  }
}

function getPastExperience() {
  // Existing flow using pastExperience for business logic,
  // this should be remove when active company changes are implemented o server
  return getExperienceDetails()
}

function getAllActiveCompanies() {
  if (isNotSalesNavigator()) {
    let allExp = getExperienceDetails()
    let activeCompanies = []
    for (let exp of allExp) {
      if (exp.timeline && exp.liCompanyUrl) {
        if (checkIsPresentTextMatch(exp.timeline)) {
          activeCompanies.push(exp.liCompanyUrl)
        }
      }
    }
    let currentCompany = getCurrentCompanyPageUrl()
    if (currentCompany) {
      currentCompany =
        'linkedin.com' + getPathnameWithQueryParam(currentCompany)
      activeCompanies.push(currentCompany)
    }
    return activeCompanies
  }
}

function getAddress() {
  if (isNotSalesNavigator()) {
    const dom = documentObject.querySelector(
      '.pv-text-details__left-panel ~ .pv-text-details__left-panel'
    )
    const domV2 = documentObject.querySelector(
      '[data-control-name="contact_see_more"]'
    )
    const domV3 = documentObject.querySelector(
      '.pv-top-card .ph5 .mt2 .mt2 span.break-words'
    )
    if (dom) {
      const element = dom.querySelectorAll('span')
      if (element.length) {
        let addressText = ''
        element.forEach(function(eleItem) {
          const address = trimSpacesAndNewLine(eleItem.innerText)
          const lcAddress = address.toLowerCase()
          if (
            !lcAddress.includes('connection') &&
            !lcAddress.includes('contact info')
          ) {
            addressText = address
          }
        })
        return addressText
      }
    } else if (domV2) {
      let element = domV2.closest('ul')
      if (element && element.querySelector('li')) {
        const address = trimSpacesAndNewLine(
          element.querySelector('li').innerText
        )
        const lowerCaseAddress = address.toLowerCase()
        if (
          lowerCaseAddress.includes('connection') ||
          lowerCaseAddress.includes('contact info')
        ) {
          return ''
        } else {
          return address
        }
        //convert string to number
      }
    } else if (domV3) {
      return trimSpacesAndNewLine(domV3.innerText)
    }
  } else {
    const address = getElementByXpath(
      '//*[@id="profile-card-section"]/section //div[contains(@class, "lockup-links-container")]/div'
    )
    return address ? trimSpacesAndNewLine(address.innerText) : ''
  }
}

function getProfileHeadline() {
  let value
  if (isNotSalesNavigator()) {
    value = documentObject.querySelector(
      '.pv-text-details__left-panel > div:last-child'
    )
    if (!value) {
        value = documentObject.querySelector('.text-body-medium.break-words');
    }
    if (!value) {
      const topCard = documentObject.querySelector('[componentkey*="Topcard"]')
      if(topCard) {
          const paragraphs = topCard.querySelectorAll('p')
          if(paragraphs.length > 0) {
              value = paragraphs[0]
          }
      }
    }
  } else {
    if (isSalesNavigatorLead()) {
      value = documentObject.querySelector(
        "#profile-card-section [data-anonymize='headline']"
      )
    } else {
      const holder = getElementByClassNameFromDom(
        'profile-topcard-person-entity__content',
        0
      )
      if (holder) {
        value = getTagNameElementFromHTMLElement(holder, 'dd', 0)
      }
    }
  }
  if (value && value.innerText) {
    return trimSpacesAndNewLine(value.innerText)
  }
}

function getCurentUrl() {
  return currentUrl
}

function getCompanyUrlForNewSn(company) {
  if (
    isValidCompany(company, 'sn_new') &&
    company &&
    company.pathname &&
    company.pathname != '/single'
  ) {
    let companyHref = getPathname(company.href)
    const urlSplit = companyHref.split('/')
    const companyId = urlSplit[urlSplit.length - 1]
    if (companyId) {
      let companyUrl = 'linkedin.com/company/' + companyId + '/'
      return companyUrl
    }
  }
}

function getCompanyUrlSn(company) {
  if (isValidCompany(company, 'sn')) {
    let url = new URL(company.href)
    if (url.searchParams.get('companyId') != undefined) {
      let companyUrl =
        'linkedin.com/company/' + url.searchParams.get('companyId') + '/'
      return companyUrl
    }
  }
}

function isValidCompany(company, arg) {
  if (company != undefined && isCurrentCompany(company, arg)) {
    return true
  }
}

function isNotSalesNavigator() {
  return !isSalesNavigator()
}

function isSalesNavigatorLead() {
  return getCurentUrl().indexOf('/sales/lead') != -1
}

function hasLinkedInCompanyPage(url) {
  return url.indexOf('search/results/index') == -1
}

function splitBySpace(name) {
  return name.split(' ')
}

function isSalesNavigator() {
  return getCurentUrl().indexOf('/sales/') != -1
}

function getExperienceDetails() {
  let pastExp = []
  if (isNotSalesNavigator()) {
    const expSect = documentObject.querySelector('#experience ~ div ul')
    const expSectionV1GroupEXPERIENCE = getElementByXpath(
      experienceSectionV1Xpath
    )
    const expSecttionUsingID = getElementByXpath(experienceSectionV2Xpath)
    if (expSect) {
      const allExp = expSect.querySelectorAll(':scope > li')
      if (allExp) {
        let iteration = 0
        for (const exp of allExp) {
          iteration++
          if (iteration != 1) {
            //skip the first company
            if (exp != undefined) {
              const data = getCompanyInfo(exp)
              pastExp.push(data)
            }
          }
        }
      }
    } else {
      let allExp = null
      if (expSectionV1GroupEXPERIENCE)
        allExp = getElementsByXpath(
          experienceSectionV1ItemXpath,
          expSectionV1GroupEXPERIENCE
        )
      else if (expSecttionUsingID) {
        allExp = getElementsByXpath(
          experienceSectionV2ItemXpath,
          expSecttionUsingID
        )
        if (!allExp || allExp.length === 0) {
            allExp = getElementsByXpath(
              experienceSectionV3ItemXpath,
              expSecttionUsingID
            )
        }
      }
      if (allExp) {
        let iteration = 0
        for (const exp of allExp) {
          iteration++
          if (iteration != 1) {
            //skip the first company
            if (exp != undefined) {
              const data = getCompanyInfoFromExpSectionV1GroupEXPERIENCE(exp)
              pastExp.push(data)
            }
          }
        }
      }
    }
  }
  return pastExp
}

function getInnerTextUsingXpath(xpath, element, oldvalue) {
  if (!oldvalue) {
    const sectionData = getElementByXpath(xpath, element)
    if (sectionData) {
      return trimSpacesAndNewLine(sectionData.innerText).replace(
        /(?:\r\n|\r|\n)/g,
        ''
      )
    }
  }
  return oldvalue
}

function checkStringContainsNumber(str) {
  return /\d/.test(str)
}

function getTitleFromV1GroupEXPERIENCE(element) {
  const titleXpathMap = [
    './div/div[2]/div[1]/div[1]/div/div/div/div/span[1]',
    './/div[contains(@class,"pvs-list__outer-container")] //a[contains(@class, "optional-action-target-wrapper")]/div/div/div/div/span[@aria-hidden="true"]'
  ]
  let title
  titleXpathMap.map(item => {
    let companyText = getInnerTextUsingXpath(item, element)
    if (companyText) title = companyText.trim()
  })
  return title
}

function getCompanyNameFromV1GroupEXPERIENCE(element) {
  const companyNameXpathMap = [
    './/div[2] /div/div/span[1]/span[1]',
    './/div[2] //a[contains(@data-field,"experience_company_logo")]/div/span/span[1]'
  ]
  let companyName
  companyNameXpathMap.map(item => {
    let companyText = getInnerTextUsingXpath(item, element)
    if (companyText && !companyName)
      companyName = companyText
        .replace('· Full-time', '')
        .replace('· Part-time', '')
        .trim()
  })
  return companyName
}

function getActivelyWorkingInfoFromV1GroupEXPERIENCE(element) {
  const experienceXpathMap = [
    './/div[2] /div/div/span[2]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[1]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[2]/span[1]'
  ]
  let isActivelyWorking = false
  experienceXpathMap.map(item => {
    let expText = getInnerTextUsingXpath(item, element)
    if (expText && checkIsPresentTextMatch(expText)) isActivelyWorking = true
  })
  return isActivelyWorking
}

function getAddressFromV1GroupEXPERIENCE(element) {
  const addressXpathMap = [
    './/div[2] /div/div/span[3]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[last()]/span[1]',
    './/div[2] /div/a/span[last()]/span[1]'
  ]
  let address = ''
  addressXpathMap.map(item => {
    let addrText = getInnerTextUsingXpath(item, element)
    if (
      addrText &&
      !checkIsPresentTextMatch(addrText) &&
      !checkStringContainsNumber(addrText)
    )
      address = addrText
  })
  return address
}

function getCompanyInfoFromExpSectionV1GroupEXPERIENCE(element) {
  let data = {}
  data.isVerifiedDomain = false //set default

  data.title = getTitleFromV1GroupEXPERIENCE(element)
  data.companyName = getCompanyNameFromV1GroupEXPERIENCE(element)
  data.isActivelyWorking = getActivelyWorkingInfoFromV1GroupEXPERIENCE(element)
  data.address = getAddressFromV1GroupEXPERIENCE(element)

  let liUrlSection = getElementByXpath('./div/div[1]/a', element)
  if (
    liUrlSection &&
    liUrlSection.href &&
    (hasLinkedInCompanyPage(liUrlSection.href) ||
      (isProspectorParser && hasLinkedInCompanyPage(currentUrl)))
  ) {
    data.companyUrl =
      'linkedin.com' + getPathnameWithQueryParam(liUrlSection.href)
    data.isVerifiedDomain = true
  }
  return data
}

function getCompanyInfo(element) {
  let data = {}
  data.isVerifiedDomain = false //set default

  let experienceListInParticularCompany = element.querySelectorAll('a:not([data-field="position_contextual_skills_see_details"])')
  
  if(!experienceListInParticularCompany || (experienceListInParticularCompany && experienceListInParticularCompany.length > 2)) {
    let name = element.querySelector('.hoverable-link-text span')
    if (name != undefined) {
      data.companyName = trimSpacesAndNewLine(name.innerText)
    } else {
      name = element.querySelector('.t-normal span')
      if (!name) {
         name = element.querySelector('.t-normal span[aria-hidden="true"]')
      }
      if (!name) {
      name = element.querySelector('.t-14.t-normal span[aria-hidden="true"]');
  }
      if (name != null) {
        data.companyName = trimSpacesAndNewLine(name.innerText).split('·')[0]
      }
    }
  } else {
    const name = element.querySelector('.t-normal span')
    if (name != null) {
      data.companyName = trimSpacesAndNewLine(name.innerText).split('·')[0]
    }
  }

  data.title = getTitleSectionFromCompanyInfo(element) || ''

  const expDateSection = element.querySelector(
    ':scope .pvs-entity__caption-wrapper'
  )
  let liUrlSection = element.parentNode
  if (
    element &&
    element.querySelector('li') &&
    element.querySelector('li').querySelector('a')
  ) {
    liUrlSection = element.querySelector('li').querySelector('a')
  } else if (element && element.querySelector('a')) {
    liUrlSection = element.querySelector('a')
  }

  if (expDateSection) {
    const timeline = trimSpacesAndNewLine(expDateSection.innerText).replace(
      'Dates Employed',
      ''
    )
    if (checkIsPresentTextMatch(timeline)) {
      data.isActivelyWorking = true
    } else {
      data.isActivelyWorking = false
    }
  }
  let locationSection = getClassNameElementFromHTMLElement(
    element,
    'pv-entity__location',
    0
  )
  let locationHiddenEle = null;
  if (locationSection) {
    locationHiddenEle = element.querySelector(
      '.pv-entity__location .visually-hidden'
    )
  } else if (expDateSection) {
    const dateSpan = expDateSection.closest('span.t-normal');
    locationSection = dateSpan ? dateSpan.nextElementSibling : null;
    if (locationSection) {
      locationHiddenEle = locationSection.querySelector(':scope .visually-hidden')
    }
  }
  if(locationSection && locationHiddenEle) {
    const hiddenTxt = locationHiddenEle.innerText.trim()
    data.address = trimSpacesAndNewLine(locationSection.innerText)
      .replace(hiddenTxt, '')
      .replace(/(?:\r\n|\r|\n)/g, '').trim()
  } else if(locationSection) {
    const locationAreaHidden = locationSection.querySelector('[aria-hidden="true"]')
    if(locationAreaHidden) {
      data.address = trimSpacesAndNewLine(locationAreaHidden.innerText).replace(/(?:\r\n|\r|\n)/g, '').trim()
    }
  }
  if (
    liUrlSection &&
    liUrlSection.href &&
    (hasLinkedInCompanyPage(liUrlSection.href) ||
      (isProspectorParser && hasLinkedInCompanyPage(currentUrl)))
  ) {
    data.companyUrl =
      'linkedin.com' + getPathnameWithQueryParam(liUrlSection.href)
    data.isVerifiedDomain = true
  }
  return data
}

function getTitleSectionFromCompanyInfo(element) {
  let titleSection
  if (
    element.querySelector(
      ':scope ul div[data-view-name="profile-component-entity"]'
    )
  ) {
    titleSection = element.querySelector(
      '.pvs-entity__sub-components ul li .visually-hidden'
    )
    if (titleSection && titleSection.innerText) {
      return trimSpacesAndNewLine(titleSection.innerText)
    }
  } else {
    titleSection = element.querySelector('.visually-hidden')
  }
  return titleSection ? trimSpacesAndNewLine(titleSection.innerText) : ''
}

function constructLinkedinIdFromWindowUrl(arg) {
  if (arg == undefined) {
    let pathname = getPathname()
    if (pathname[pathname.length - 1] == '/') {
      pathname = pathname.substring(0, pathname.length - 1)
    }
    let linkedinId = 'linkedin.com' + pathname
    return linkedinId
  }
}

function getDataByClassNameTagName(className, classNode, tagName, tagNode) {
  let dataSection = getElementByClassNameFromDom(className, classNode)
  if (dataSection != undefined) {
    let dataElement = getTagNameElementFromHTMLElement(
      dataSection,
      tagName,
      tagNode
    )
    return dataElement
  }
}

function hasMultipleTitle(expSelector) {
  return documentObject.querySelector(
    `${expSelector} > li:first-child ul div[data-view-name="profile-component-entity"]`
  )
}

function getElementByClassNameFromDom(className, node) {
  let value = documentObject.getElementsByClassName(className)
  if (node != null) {
    // dont replace with if(node) as node value can be 0
    if (value[node]) {
      return value[node]
    }
  } else {
    return value
  }
}

function getElementByXpath(path, element) {
  return document.evaluate(
    path,
    element || documentObject,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue
}

function getElementsByXpath(path, element) {
  let results = []
  let query = document.evaluate(
    path,
    element || documentObject,
    null,
    XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
    null
  )
  for (let i = 0, length = query.snapshotLength; i < length; ++i) {
    results.push(query.snapshotItem(i))
  }
  return results
}

function findWordsContainingKey(key, content) {
  if (content) {
    content = trimSpacesAndNewLine(content.innerText)
    const regex = new RegExp('\\S+[a-z0-9]' + key + '[a-z0-9.]+', 'gim')
    return content.match(regex)
  }
}

function getTagNameElementFromDom(tagName, node) {
  let value = documentObject.getElementsByTagName(tagName)
  if (node != null) {
    // if(node) is not used because, if node = 0 it become false
    if (value[node]) {
      return value[node]
    }
  } else {
    return value
  }
}

function getDataByClassNameClassName(class1, classNode1, class2, classNode2) {
  let dataSection = getElementByClassNameFromDom(class1, classNode1)
  if (dataSection != undefined) {
    let dataElement = getClassNameElementFromHTMLElement(
      dataSection,
      class2,
      classNode2
    )
    return dataElement
  }
}

function getTagNameElementFromHTMLElement(element, tagName, node) {
  if (element && element.getElementsByTagName(tagName).length > 0) {
    let value = element.getElementsByTagName(tagName)
    if (node != null) {
      // if(node) is not used because, if node = 0 it become false
      if (value[node]) {
        return value[node]
      }
    } else {
      return value
    }
  }
}

function getClassNameElementFromHTMLElement(element, className, node) {
  let value = element.getElementsByClassName(className)
  if (node != null) {
    if (value[node]) {
      return element.getElementsByClassName(className)[node]
    }
  } else {
    return value
  }
}

function isCurrentCompany(element, arg) {
  let dateRange
  if (arg && arg === 'sn_new') {
    let dataSection = element.parentElement
    dateRange = getClassNameElementFromHTMLElement(
      dataSection,
      'profile-position__dates-employed',
      0
    )
  } else if (arg) {
    let dataSection = element.parentElement.parentElement
    dateRange = getTagNameElementFromHTMLElement(dataSection, 'span', 0)
  } else {
    element = element.parentElement.parentElement
    dateRange = element.querySelector(
      '.pvs-entity__sub-components .pvs-entity__caption-wrapper'
    )
    if (!dateRange) {
      dateRange = getClassNameElementFromHTMLElement(
        element,
        'pvs-entity__caption-wrapper',
        0
      )
    }
  }

  if (dateRange != undefined) {
    let presentParseStr = dateRange.innerText
    const dateSplitArr1 = presentParseStr.split('–')
    const dateSplitArr2 = presentParseStr.split('-')

    if (dateSplitArr1.length > 1) presentParseStr = dateSplitArr1[1]
    else if (dateSplitArr2.length > 1) presentParseStr = dateSplitArr2[1]

    const isMatched = checkIsPresentTextMatch(presentParseStr)
    return isMatched
  }
  return false
}
/* Single Parser Ends */

/* Bulk Parser Starts */
const fetchBulkDataParserFun = () => {
  return new Promise(resolve => {
    if (isSalesNavigatorList()) {
      isAllContentsLoadedInSalesNavigatorList(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject))
      })
    } else if (!isSalesnavigatorBulk()) {
      isAllContentsLoaded(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject))
      })
    } else {
      isAllContentsLoadedInSalesNavigator(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject))
      })
    }
  })
}

function isAllContentsLoaded(i) {
  return delay(400).then(() => {
    if (!isProspectorParser) window.scrollBy(0, 300)
    let totalContacts = 0
    let totalLoaded = 0
    if (documentObject.querySelectorAll('.search-results__list')[0]) {
      totalContacts = documentObject
        .querySelectorAll('.search-results__list')[0]
        .querySelectorAll('li').length
      totalLoaded = documentObject.querySelectorAll('.search-result__image')
        .length
    } else if (
      documentObject.querySelectorAll(
        '.reusable-search__entity-results-list'
      )[0]
    ) {
      totalContacts = documentObject
        .querySelectorAll('.reusable-search__entity-results-list')[0]
        .querySelectorAll('li').length
      totalLoaded = documentObject.querySelectorAll('.entity-result__item')
        .length
    }
    else if(documentObject.querySelectorAll('div[data-view-name="people-search-result"]')[0])
      {
        totalLoaded = documentObject.querySelectorAll('div[data-view-name="people-search-result"]').length
        totalContacts = documentObject.querySelectorAll('a[data-view-name="search-result-lockup-title"]').length
    }
    if (totalLoaded == totalContacts && totalContacts != 0) {
      if (!isProspectorParser) window.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 4 && !isProspectorParser) {
        return isAllContentsLoaded(i)
      } else {
        return
      }
    }
  })
}

function isAllContentsLoadedInSalesNavigatorList(i) {
  return delay(300).then(() => {
    // if (!isProspectorParser) window.scrollBy(0, 300)
    let totalResults = document.querySelectorAll('.artdeco-models-table-row')
    if(totalResults.length == 0) {
      totalResults = document.querySelectorAll('.people-list-detail__table tbody tr')
    }
    let totalContacts =
      totalResults.length && totalResults.length > 25 ? totalResults.length : 25

    const totalLoadedV1 = documentObject.querySelectorAll(
      '.lists-detail__view-profile-name-link'
    ).length

    const totalLoadedV2 = documentObject.querySelectorAll(
      '.list-detail_name-and_badge div:first-child button span'
    ).length

    const totalLoaded = totalLoadedV1 || totalLoadedV2

    if (totalLoaded >= totalContacts) {
      if (!isProspectorParser) window.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 4 && !isProspectorParser) {
        return isAllContentsLoadedInSalesNavigatorList(i)
      } else {
        if (!isProspectorParser) window.scrollTo(0, 0)
        return
      }
    }
  })
}

function isAllContentsLoadedInSalesNavigator(i) {
  return delay(600).then(() => {
    const resultsContainer = documentObject.getElementById(
      'search-results-container'
    )
    if (!isProspectorParser && resultsContainer)
      resultsContainer.scrollBy({ left: 0, top: 300, behavior: 'smooth' })

    const totalResults = documentObject.querySelectorAll('.artdeco-list__item')
    let totalContacts = 25
    if (totalResults) {
      totalContacts = totalResults.length
      if (totalContacts > 25) totalContacts = 25
    }

    const totalLoaded = documentObject.querySelectorAll(
      '.artdeco-entity-lockup__title'
    ).length
    if (totalLoaded >= totalContacts) {
      if (!isProspectorParser && resultsContainer)
        resultsContainer.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 15 && !isProspectorParser) {
        return isAllContentsLoadedInSalesNavigator(i)
      } else {
        if (!isProspectorParser && resultsContainer)
          resultsContainer.scrollTo(0, 0)
        return
      }
    }
  })
}

function isSalesnavigatorBulk() {
  return getCurentUrl().indexOf('/sales/search/people') != -1
}

function isSalesNavigatorList() {
  return getCurentUrl().indexOf('/sales/lists/people') != -1
}

function delay(ms) {
  return new Promise(function(resolve, reject) {
    return setTimeout(resolve, ms)
  })
}

function getAllProfileDataBulk(dom) {
  let contactList = []
  if (isServerParserEnabled) {
    const profileData = {}
    profileData.isServerParserEnabled = true
    profileData.profileHTML = document.documentElement.innerHTML
    profileData.currentUrl = window.location.href
    return profileData
  } else {
    if (isSalesNavigatorList()) {
      let list = documentObject.querySelectorAll(
        '.artdeco-models-table-row.ember-view'
      )
      if (!list || list.length == 0) {
        list = documentObject.querySelectorAll(
          '.people-list-detail__table tbody tr'
        )
      }
      if (list) {
        for (let item of list) {
          const contact = getContactDataFromSnList(item)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            contactList.push(contact)
        }
      }
    } else if (!isSalesnavigatorBulk()) {
      let listItems = dom.querySelectorAll('ul.search-results__list li')
      let bulkParserType = 'v1'
      if (listItems.length === 0) {
        listItems = dom.querySelectorAll(
          'ul.reusable-search__entity-result-list li.reusable-search__result-container'
        )
        bulkParserType = 'v2'
      }
      if (listItems.length === 0) {
        var parentListSelector = getElementByXpath(
          "//div[contains(@class,'search-results-container')]//ul/li/div[@data-view-name='search-entity-result-universal-template']/ancestor::ul",
          dom
        )
        listItems = getElementsByXpath('./li', parentListSelector)
        bulkParserType = 'v3'
      }
      if (listItems.length === 0) {
        var peopleContainers = getElementsByXpath("//div[@data-view-name='people-search-result']")
        if (peopleContainers.length > 0) {
          listItems = peopleContainers
          bulkParserType = 'v4'
        }
      }
      if (listItems) {
        for (let item of listItems) {
          const contact = getContactData(item, bulkParserType)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            contactList.push(contact)
        }
      }
    } else {
      const list = documentObject.querySelectorAll('.result-lockup')
      const listV1 = documentObject.querySelectorAll('li.artdeco-list__item')

      if (list.length > 0) {
        for (let item of list) {
          const contact = getContactDataFromSn(item)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            contactList.push(contact)
        }
      } else if (listV1.length > 0) {
        for (let item of listV1) {
          const contact = getContactDataFromSnV1(item)

          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            contactList.push(contact)
        }
      }
    }
  }
  return contactList
}

function findFirstNonNullValueFromList(list) {
  for (let item of list) {
    if(item) {
      return item.innerText
    }
  }
  return null
}

function getContactDataFromSnList(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolderV1 = ele.querySelector(
    '.lists-detail__view-profile-name-link'
  )
  const nameHolderV2 = ele.querySelector(
    '.list-detail_name-and_badge div:first-child button span'
  )

  const summaryHolderV1 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 dl div div'
  )
  const summaryHolderV2 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 .list-detail_name-and_badge + div div'
  )
  const summaryHolderV3 = ele.querySelector('[data-anonymize="job-title"]')

  const companyHolder = ele.querySelector('.company-entity')

  const title = findFirstNonNullValueFromList([
    summaryHolderV1, summaryHolderV2, summaryHolderV3
  ])
  if (title) {
    data['title'] = trimSpacesAndNewLine(title)
    data['currentSummary'] = trimSpacesAndNewLine(title)
  }
  if (companyHolder) {
    const cName = companyHolder.querySelector('[data-anonymize="company-name"]')
    data['companyName'] = cName ? cName.innerText.trim() : companyHolder.innerText.trim()

    if (companyHolder.querySelector('a'))
      data['companyUrl'] = getLiCPUrl(companyHolder.querySelector('a').href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  if (nameHolderV1 || nameHolderV2)
    data['fullName'] = trimSpacesAndNewLine(
      nameHolderV1
        ? nameHolderV1.innerText
        : nameHolderV2
        ? nameHolderV2.innerText.split(',')[0]
        : ''
    )
  const linkElementV2 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 figure a'
  )
  let linkedinId = nameHolderV1
    ? getPathname(nameHolderV1.href) + getSearchStringFromUrl(nameHolderV1.href)
    : linkElementV2
    ? getPathname(linkElementV2.href) +
      getSearchStringFromUrl(linkElementV2.href)
    : ''

  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  return data
}

function getContactDataFromSn(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolder = ele.querySelector('.result-lockup__name')
  const summaryHolder = ele.querySelector('.result-lockup__highlight-keyword')
  const companyHolder = ele.querySelector('.result-lockup__position-company')
  if (summaryHolder && companyHolder) {
    data['title'] = trimSpacesAndNewLine(summaryHolder.innerText)
      .replace(trimSpacesAndNewLine(companyHolder.innerText), '')
      .replace(' at ', '')
    data['companyName'] = companyHolder.innerText.trim().split('\n')[0]
    data['companyUrl'] = getLiCPUrl(companyHolder.querySelector('a').href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  nameHolder && (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))
  let linkedinId =
    (nameHolder &&
      getPathname(nameHolder.querySelector('a').href) +
        getSearchStringFromUrl(nameHolder.querySelector('a').href)) ||
    ''
  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  summaryHolder &&
    (data['currentSummary'] = trimSpacesAndNewLine(summaryHolder.innerText))
  return data
}

function getContactDataFromSnV1(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolder = ele.querySelector('.artdeco-entity-lockup__title')
  const summaryHolder = ele.querySelector('.artdeco-entity-lockup__subtitle')

  if (summaryHolder) {
    const titleEle = summaryHolder.querySelector('span')
    if (titleEle) data['title'] = trimSpacesAndNewLine(titleEle.innerText)
  }

  const companyHolder = ele.querySelector('.artdeco-entity-lockup__subtitle a')
  if (companyHolder) {
    data['companyName'] = companyHolder.innerText.trim().split('\n')[0]
    data['companyUrl'] = getLiCPUrl(companyHolder.href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  nameHolder && (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))

  let linkedinId =
    (nameHolder &&
      getPathname(nameHolder.querySelector('a').href) +
        getSearchStringFromUrl(nameHolder.querySelector('a').href)) ||
    ''
  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  summaryHolder &&
    (data['currentSummary'] = trimSpacesAndNewLine(summaryHolder.innerText))
  return data
}

function hasValidCompanyPage(url) {
  return url.indexOf('/search') == -1
}

function getLiCPUrl(url) {
  if (url && hasValidCompanyPage(url)) {
    const elements = getPathname(url).split('/')
    const companyId = elements[elements.length - 1]
    return 'linkedin.com/company/' + companyId + '/'
  }
}

function getContactData(ele, bulkParserType) {
  if (bulkParserType == 'v1') {
    let data = {}
    const nameHolder = ele.querySelector('.actor-name')
    const summaryHolder = ele.querySelector('.subline-level-1')
    const addressHolder = ele.querySelector('.subline-level-2')
    const otherSummaryHolder = ele.querySelector('.search-result__snippets')
    const linkedinIdHolder = ele.querySelector('a')
    if (!nameHolder) {
      return null
    }

    nameHolder &&
      (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))
    summaryHolder &&
      (data['summary'] = trimSpacesAndNewLine(summaryHolder.innerText))
    addressHolder &&
      (data['address'] = trimSpacesAndNewLine(addressHolder.innerText))
    let currentCompany = getPathname(linkedinIdHolder.href)
    if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }

    linkedinIdHolder && (data['linkedinId'] = currentCompany)
    if (otherSummaryHolder) {
      if (otherSummaryHolder.innerText.toLowerCase().indexOf('past:') != -1) {
        data['pastSummary'] = trimSpacesAndNewLine(
          otherSummaryHolder.innerText
        ).replace('Past:', '')
      } else if (
        otherSummaryHolder.innerText.toLowerCase().indexOf('current:') != -1
      ) {
        data['currentSummary'] = trimSpacesAndNewLine(
          otherSummaryHolder.innerText
        ).replace('Current:', '')
      }
    }
    return data
  } else if (bulkParserType == 'v3') {
  let data = {}

  let container =
    ele.querySelector('.mb1') || ele.querySelector('.t-roman.t-sans')

  if (!container) return null

  let nameHolder = container.querySelector('a span[aria-hidden="true"]')
  let summaryHolder = container.querySelector('div:nth-of-type(2)')
  let addressHolder = container.querySelector('div:nth-of-type(3)')
  let linkedinIdHolder = container.querySelector('a')

  let nameStr = (nameHolder && nameHolder.innerText
  ? nameHolder.innerText.trim()
  : '')

  if (!nameStr) return null

  nameStr && (data['fullName'] = trimSpacesAndNewLine(nameStr))
  summaryHolder &&
      (data['summary'] = trimSpacesAndNewLine(summaryHolder.innerText))
  addressHolder &&
      (data['address'] = trimSpacesAndNewLine(addressHolder.innerText))

  let currentCompany = getPathname(linkedinIdHolder.href)
  if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }
    linkedinIdHolder && (data['linkedinId'] = currentCompany)
    return data
  } 
  else if (bulkParserType == 'v4') 
  {
      let data = {}
      const linkedinIdHolder = ele.querySelector('a[data-view-name="search-result-lockup-title"]')
      const peopleContainer = ele
  
    // Find the name link within this container
      const nameLink = peopleContainer.querySelector('a[data-view-name="search-result-lockup-title"]')
  
      if (!nameLink) {
        return null
      }
  
    // Get the name
      const fullName = trimSpacesAndNewLine(nameLink.innerText)
      if (!fullName || fullName === 'LinkedIn Member') {
        return null
      }
    
      data['fullName'] = fullName
    
      // Find the main p tag that contains the name
      const namePTag = nameLink.closest('p')
    
    if (namePTag) {
    // Get all following sibling p tags
      const siblingPTags = []
      let nextSibling = namePTag.nextElementSibling
      
      // Collect all p tag siblings
      while (nextSibling && nextSibling.tagName === 'P') {
        siblingPTags.push(nextSibling)
        nextSibling = nextSibling.nextElementSibling
      }
      
      // First sibling p tag is usually designation/summary
      if (siblingPTags.length >= 1) {
        data['summary'] = trimSpacesAndNewLine(siblingPTags[0].innerText)
      }
      
      // Second sibling p tag is usually location/address
      if (siblingPTags.length >= 2) {
        data['address'] = trimSpacesAndNewLine(siblingPTags[1].innerText)
      }
    }
  
    // Get LinkedIn profile URL
      let currentCompany = getPathname(linkedinIdHolder.href)
    if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }
    data["linkedinId"] = currentCompany
    return data
  } 
  else {
    let data = {}
    const nameHolder =
      ele.querySelector('.entity-result__title-text a') ||
      ele.querySelector('.entity-result__title-line a span[aria-hidden="true"')
    const summaryHolder = ele.querySelector('.entity-result__primary-subtitle')
    const addressHolder = ele.querySelector(
      '.entity-result__secondary-subtitle'
    )
    const linkedinIdHolder = ele.querySelector('a')

    let nameStr =
      nameHolder && nameHolder.innerText ? nameHolder.innerText.trim() : ''
    const nameHiddenEle = ele.querySelector(
      '.entity-result__title-text a .visually-hidden'
    )
    const nameHiddenTxt = nameHiddenEle ? nameHiddenEle.innerText.trim() : ''

    if (nameHiddenTxt != '') {
      nameStr = nameStr.replace(nameHiddenTxt, '')
    }

    if (!nameHolder || nameStr == '') {
      return null
    }
    nameStr && (data['fullName'] = trimSpacesAndNewLine(nameStr))
    summaryHolder &&
      (data['summary'] = trimSpacesAndNewLine(summaryHolder.innerText))
    addressHolder &&
      (data['address'] = trimSpacesAndNewLine(addressHolder.innerText))
    let currentCompany = getPathname(linkedinIdHolder.href)
    if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }

    linkedinIdHolder && (data['linkedinId'] = currentCompany)
    return data
  }
}
/* Bulk Parser Ends */

/* Company Parser Starts */

const isContentLoadedInSalesNavigatorCompany = i => {
  return delay(600).then(() => {
    const resultsContainer = documentObject.getElementsByClassName(
      'account-page-section'
    )

    if (resultsContainer && resultsContainer[0]) {
      return
    } else {
      i++
      if (i < 15 && !isProspectorParser) {
        return isContentLoadedInSalesNavigatorCompany(i)
      } else {
        return
      }
    }
  })
}

const salesNavigatorCompanyParser = () => {
  return new Promise(resolve => {
    isContentLoadedInSalesNavigatorCompany(0).then(() => {
      resolve(getCompanyDataFromSalesNavigator(documentObject))
    })
  })
}

const assignValueIfElementAvailable = (data, element, key, attribute) => {
  if (element !== undefined && element !== null) {
    if (attribute) {
      data[key] = trimSpacesAndNewLine(element.attributes[attribute].value)
    } else {
      data[key] = trimSpacesAndNewLine(element.innerText)
    }
  }
}

const metaDataKeys = [
  { key: 'founded', text: 'founded' },
  { key: 'companyType', text: 'type' }
]

const getCompanyDataFromSalesNavigator = () => {
  if (isServerParserEnabled) {
    const companyData = {}
    companyData.isServerParserEnabled = true
    companyData.profileHTML = document.documentElement.innerHTML
    companyData.currentUrl = window.location.href
    return companyData
  } else {
    const companyData = {}
    const companyInfoSection = documentObject.getElementsByClassName(
      'account-page-section'
    )[0]
    if (companyInfoSection) {
      const about = companyInfoSection.querySelector(
        'section p[data-anonymize="company-blurb"]'
      )

      assignValueIfElementAvailable(companyData, about, 'about')

      const metadataWrapper = companyInfoSection.querySelector(
        "[class*='metadata-wrapper']"
      )
      if (metadataWrapper) {
        metadataWrapper
          .querySelectorAll(':scope > div')
          .forEach(function(element, index) {
            const headerText = element.querySelector(':scope > dt')
            const matchedKey = metaDataKeys.find(keyObj => {
              return (
                keyObj.text ===
                trimSpacesAndNewLine(headerText.innerText).toLowerCase()
              )
            })
            assignValueIfElementAvailable(
              companyData,
              element.querySelector(':scope > dd'),
              matchedKey.key
            )
          })
      }
      const linksContainer = companyInfoSection.querySelector(
        "[class*='search-leads-container']"
      )
      if (linksContainer) {
        const cLevelCount = linksContainer.querySelectorAll(
          ':scope > section'
        )[1]
        try {
          companyData['cLevelCount'] = trimSpacesAndNewLine(
            cLevelCount
              .querySelector('a')
              .innerText.match(/\(.*\)/)[0]
              .replace('(', '')
              .replace(')', '')
          )
        } catch (e) {}
      }
    }
    const sideBarContainer = documentObject.querySelector('nav header')
    if (sideBarContainer) {
      const companyName = sideBarContainer.querySelector(
        "[data-anonymize='company-name']"
      )
      assignValueIfElementAvailable(companyData, companyName, 'name')
      const industry = sideBarContainer.querySelector(
        "[data-anonymize='industry']"
      )
      assignValueIfElementAvailable(companyData, industry, 'industry')
      const location = sideBarContainer.querySelector(
        "[data-anonymize='location']"
      )
      assignValueIfElementAvailable(companyData, location, 'location')
      const employeeCount = sideBarContainer.querySelector(
        "[data-anonymize='company-size'] span"
      )
      assignValueIfElementAvailable(companyData, employeeCount, 'employeeCount')
      const website = sideBarContainer.querySelector('.account-actions a')
      assignValueIfElementAvailable(companyData, website, 'website', 'href')
    }
    return companyData
  }
}

/* Company Parser Ends */

export const checkIsPresentTextMatch = (text, language) => {
  let presentText = 'present'
  const selectedLanguage =
    language !== undefined ? language : LI_CHOOSEN_LANGUAGE

  if (selectedLanguage !== '') {
    if (
      LI_LANGUAGE_MAP[selectedLanguage] !== undefined &&
      LI_LANGUAGE_MAP[selectedLanguage].presentText !== undefined
    ) {
      presentText = LI_LANGUAGE_MAP[selectedLanguage].presentText.toLowerCase()
    }
  }

  return text.toLowerCase().indexOf(presentText) != -1
}

export const LI_LANGUAGE_MAP = {
  ar_AE: {
    languageName: 'العربية (Arabic)',
    presentText: 'الحالي'
  },
  cs_CZ: {
    languageName: 'Čeština (Czech)',
    presentText: 'do současnosti'
  },
  da_DK: {
    languageName: 'Dansk (Danish)',
    presentText: 'nu'
  },
  de_DE: {
    languageName: 'Deutsch (German)',
    presentText: 'Heute'
  },
  en_US: {
    languageName: 'English (English)',
    presentText: 'present'
  },
  es_ES: {
    languageName: 'Español (Spanish)',
    presentText: 'actualidad'
  },
  fr_FR: {
    languageName: 'Français (French)',
    presentText: 'Aujourd’hui'
  },
  in_ID: {
    languageName: 'Bahasa Indonesia (Bahasa Indonesia)',
    presentText: 'Saat ini'
  },
  it_IT: {
    languageName: 'Italiano (Italian)',
    presentText: 'presente'
  },
  ja_JP: {
    languageName: '日本語 (Japanese)',
    presentText: '現在'
  },
  ko_KR: {
    languageName: '한국어 (Korean)',
    presentText: '현재'
  },
  ms_MY: {
    languageName: 'Bahasa Malaysia (Malay)',
    presentText: 'Kini'
  },
  nl_NL: {
    languageName: 'Nederlands (Dutch)',
    presentText: 'heden'
  },
  no_NO: {
    languageName: 'Norsk (Norwegian)',
    presentText: 'nå'
  },
  pl_PL: {
    languageName: 'Polski (Polish)',
    presentText: 'obecnie'
  },
  pt_BR: {
    languageName: 'Português (Portuguese)',
    presentText: 'o momento'
  },
  ro_RO: {
    languageName: 'Română (Romanian)',
    presentText: 'Prezent'
  },
  ru_RU: {
    languageName: 'Русский (Russian)',
    presentText: 'настоящее время'
  },
  sv_SE: {
    languageName: 'Svenska (Swedish)',
    presentText: 'nu'
  },
  th_TH: {
    languageName: 'ภาษาไทย (Thai)',
    presentText: 'ปัจจุบัน'
  },
  tl_PH: {
    languageName: 'Tagalog (Tagalog)',
    presentText: 'Kasalukuyan'
  },
  tr_TR: {
    languageName: 'Türkçe (Turkish)',
    presentText: 'Şu Anda'
  },
  zh_CN: {
    languageName: '简体中文 (Chinese (Simplified))',
    presentText: '至今'
  },
  zh_TW: {
    languageName: '正體中文 (Chinese (Traditional))',
    presentText: '目前'
  }
}